export interface FileApiResource {
  id: string;
  patient_id: string;
  session_note_id: string | null;
  treatment_plan_exercise_id: string | null;
  filename: string;
  content_type: string;
  size_bytes: number;
  width: number | null;
  height: number | null;
  visibility: string;
  source: string;
  status: string;
  review_note: string | null;
  created_at: string;
  download_url: string | null;
  thumbnail_url: string | null;
}

export interface PatientFile {
  id: string;
  patientId: string;
  sessionNoteId: string | null;
  treatmentPlanExerciseId: string | null;
  filename: string;
  contentType: string;
  sizeBytes: number;
  width: number | null;
  height: number | null;
  visibility: string;
  source: string;
  status: string;
  reviewNote: string | null;
  createdAt: string;
  downloadUrl: string | null;
  thumbnailUrl: string | null;
}

export interface FileUploadInitApiResource {
  file_id: string;
  upload_url: string;
  content_type: string;
  method: string;
}

export interface FileUploadInit {
  fileId: string;
  uploadUrl: string;
  contentType: string;
  method: string;
}

export interface FileUploadInitPayload {
  filename: string;
  contentType: string;
  sizeBytes: number;
  visibility?: string;
  sessionNoteId?: string;
  treatmentPlanExerciseId?: string;
}

export function mapApiResourceToFile(resource: FileApiResource): PatientFile {
  return {
    id: resource.id,
    patientId: resource.patient_id,
    sessionNoteId: resource.session_note_id,
    treatmentPlanExerciseId: resource.treatment_plan_exercise_id,
    filename: resource.filename,
    contentType: resource.content_type,
    sizeBytes: resource.size_bytes,
    width: resource.width,
    height: resource.height,
    visibility: resource.visibility,
    source: resource.source,
    status: resource.status,
    reviewNote: resource.review_note,
    createdAt: resource.created_at,
    downloadUrl: resource.download_url,
    thumbnailUrl: resource.thumbnail_url,
  };
}

export function mapApiResourceToFileUploadInit(
  resource: FileUploadInitApiResource
): FileUploadInit {
  return {
    fileId: resource.file_id,
    uploadUrl: resource.upload_url,
    contentType: resource.content_type,
    method: resource.method,
  };
}

export function mapFileUploadInitPayload(
  payload: FileUploadInitPayload
): Record<string, unknown> {
  const mapped: Record<string, unknown> = {
    filename: payload.filename,
    content_type: payload.contentType,
    size_bytes: payload.sizeBytes,
  };
  if (payload.visibility !== undefined) {
    mapped.visibility = payload.visibility;
  }
  if (payload.sessionNoteId !== undefined) {
    mapped.session_note_id = payload.sessionNoteId;
  }
  if (payload.treatmentPlanExerciseId !== undefined) {
    mapped.treatment_plan_exercise_id = payload.treatmentPlanExerciseId;
  }
  return mapped;
}
